import styled from 'styled-components';

import media from '../../../../styles/media.style';
import { WHITE, BG_GRAY, BLACK } from '../../../../styles/variables.style';

export const Title = styled.h1`
  font-size: 20px;
  text-transform: uppercase;

  ${media.tabletL`
    max-width: 80%;
    font-size: 24px;
    text-align: center;
    margin: 0 auto;
  `};
`;

export const SlideWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 500px;

  ${media.tabletL`
    flex-direction: row;
    min-height: auto;
    height: 550px;
    background-color: ${WHITE};
    align-items: center;
  `};
`;

export const ImageWrapper = styled.div`
  background-color: ${BG_GRAY.COMMON_5};
  background-image: url(${({ image }) => `${image.url}?w=${Math.floor(image.details.image.width / 3)}&q=100`});
  background-position: 45px;
  background-repeat: no-repeat;
  background-size: cover;
  height: 126px;
  max-width: 125px;
  padding-left: 45px;

  ${media.x2`
    background-image: url(${({ image }) =>
      image ? `${image.url}?w=${Math.floor(image.details.image.width / 1.5)}&q=100` : 'unset'});
  `};

  ${media.x3`
    background-image: url(${({ image }) => (image ? `${image.url}` : 'unset')});
  `};

  img {
    display: block;
  }

  ${media.tabletL`
    background-color: transparent;
    background-image: none;
    flex: ${({ medium, small }) => {
      if (medium) return 1;
      if (small) return 3;
      return 1;
    }};
    height: auto;
    max-width: ${({ size }) => size}px;
    min-width: ${({ size }) => size}px;
    padding-left: 0;
  `};
`;

export const DesktopImageWrapper = styled.div`
  display: none;

  ${media.tabletL`
    display: block;
  `};
`;

export const ContentWrapper = styled.div`
  ${media.tabletL`
    margin-top: 0;
    padding: 0;
    display: flex;
    height: 100%;
    order: ${({ left }) => (left ? -1 : 0)}
    flex: ${({ medium, small }) => {
      if (medium) return 1;
      if (small) return 2;
      return 3;
    }};
  `};
`;

export const DropdownWrapper = styled.div`
  margin: 0 auto;

  > div {
    margin-bottom: 24px;
  }
`;

export const Subtitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  max-width: 250px;
  margin-bottom: 35px;

  ${media.tabletL`
    text-align: center;
    margin: 12px auto 30px;
  `};
`;

export const AnswersWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;

  li {
    display: block;
    position: relative;
    width: 100%;
  }

  ${media.tabletL`
    margin: 0 auto;
    width: 80%;
  `};
`;

export const ListBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  margin: 5px 0 0 5px;
  padding: 15px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  z-index: 1;
  width: 100%;
  height: 100%;
  line-height: 1.5;
  outline: none;

  ${media.tabletL`
    padding: 20px;
    text-align: center;
  `};
`;

export const QuestionWrapper = styled.div`
  align-items: center;
  background-color: ${({ darker, left }) => {
    if (darker) {
      if (left) {
        return darker === BG_GRAY.COMMON_1 ? BG_GRAY.COMMON_1 : WHITE;
      }
      return darker === BG_GRAY.COMMON_1 ? WHITE : BG_GRAY.COMMON_1;
    }
    return WHITE;
  }};
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  justify-content: ${({ double }) => (double ? 'flex-start' : 'center')};
  margin: 0 auto;
  padding: 30px 45px;

  ${media.tabletL`
    padding: ${({ double }) => (double ? '3em 0 0' : ' 0')};
    background-color: ${({ darker }) => {
      if (darker) {
        return darker === BG_GRAY.COMMON_1 ? BG_GRAY.COMMON_1 : WHITE;
      }
      return WHITE;
    }};

    ${AnswersWrapper} {
      li {
        display: block;
        width: ${({ double }) => (double ? '100%' : '50%')};
      }
    }
  `};
`;

export const BackgroundBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% + 5px);
  height: calc(100% + 5px);
  z-index: 0;
`;

export const IconWrapper = styled.span`
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-right: 10px;
`;

export const Description = styled.p`
  font-size: 12px;
  font-weight: 400;
  margin: 1em 0;
  text-transform: uppercase;

  ${media.tabletL`
    margin: 1em auto;
    text-align: center;
  `};
`;

export const SliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 4em auto 0;
  width: 70%;

  svg {
    align-self: center;
  }

  p {
    font-size: 10px;
    :first-child {
      text-align: right;
    }
    :last-child {
      text-align: left;
    }
  }
`;

export const SlideProgress = styled.p`
  position: absolute;
  top: 116px;
  right: 45px;
  font-size: 10px;
  font-weight: 600;
  color: #cacaca;
  margin: 0;

  span {
    font-size: 10px;
    font-weight: 900;
    color: ${BLACK};
  }

  ${media.tabletL`
    display: none;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisHomePage/Slides/Question.style.js